import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ComponentPropsWithoutRef, RefObject } from "react";
import { useState } from "react";
import type ReCAPTCHA from "react-google-recaptcha";

import type { CurrentCommunity } from "@/react/types/CurrentCommunity";
import type { CurrentUser } from "@/react/types/CurrentUser";

import { ErrorPageContentV4 } from "./ErrorPageContentV4";
import { ErrorPageFooterV4 } from "./ErrorPageFooterV4";
import { ErrorReportModalV4 } from "./ErrorReportModalV4";

interface ErrorTemplateV4Props {
  brandColor?: string;
  communityUrl: string;
  currentCommunity?: CurrentCommunity;
  currentUser?: CurrentUser;
  errorCode: number;
  fullHeight?: boolean;
  logoUrl: string;
  onSubmit: NonNullable<ComponentPropsWithoutRef<"form">["onSubmit"]>;
  passThroughProps: Record<string, unknown>;
  recaptchaRef: RefObject<ReCAPTCHA | null>;
  title: string;
}

export const ErrorTemplateV4 = ({
  brandColor,
  communityUrl,
  currentCommunity,
  currentUser,
  errorCode,
  fullHeight = false,
  logoUrl,
  onSubmit,
  passThroughProps,
  recaptchaRef,
  title,
}: ErrorTemplateV4Props) => {
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);

  const goToHomepage = () => {
    window.location.href = communityUrl;
  };

  return (
    <div
      className={classNames(
        "bg-primary flex flex-col",
        fullHeight ? "min-h-dvh" : "min-h-full",
      )}
    >
      <main className="flex flex-1 items-center justify-center px-0 py-12 lg:px-6">
        <ErrorPageContentV4
          brandColor={brandColor}
          communityUrl={communityUrl}
          currentCommunity={currentCommunity}
          errorCode={errorCode}
          logoUrl={logoUrl}
          onGoToHomepage={goToHomepage}
          onReportError={() => setIsReportModalOpen(true)}
          onTryAgain={() => window.location.reload()}
          title={title}
        />
      </main>

      <ErrorPageFooterV4 currentUser={currentUser} />

      <ErrorReportModalV4
        errorCode={errorCode}
        isOpen={isReportModalOpen}
        onOpenChange={setIsReportModalOpen}
        onSubmit={onSubmit}
        passThroughProps={passThroughProps}
        recaptchaRef={recaptchaRef}
      />
    </div>
  );
};
